import OutboundLink from "../OutboundLink";
import Image from "next/image";

export const Events = () => {
  return (
    <div className="mx-auto max-w-screen-large">
      <h2 className="mb-8 text-center text-4xl leading-tight medium:mb-14 medium:text-[64px]">
        Events
      </h2>
      <OutboundLink href="https://events.xqsuperschool.org/xqcompetencies_learning_2025">
        <Image
          src="/assets/homepage/events_xs.png"
          alt="learn more about XQ events"
          width={328}
          height={418}
          className="small:hidden"
        />
        <Image
          src="/assets/homepage/events_small.png"
          alt="learn more about XQ events"
          width={736}
          height={736}
          className="hidden small:block medium:hidden"
        />
        <Image
          src="/assets/homepage/events_medium.png"
          alt="learn more about XQ events"
          width={976}
          height={308}
          className="hidden medium:block large:hidden"
        />
        <Image
          src="/assets/homepage/events_large.png"
          alt="learn more about XQ events"
          width={1392}
          height={440}
          className="hidden large:block"
        />
      </OutboundLink>
    </div>
  );
};
